import useSWR from 'swr';

import { fetchCategories, type Category } from '../data/categoriesRepository.js';

export const CATEGORIES_KEY = 'categories/list';

export type CategoriesState =
  | { status: 'loading' }
  | { status: 'error'; message: string; retry: () => void }
  | { status: 'ready'; categories: readonly Category[]; refresh: () => Promise<unknown> };

export function useCategories(): CategoriesState {
  const { data, error, isLoading, mutate } = useSWR<readonly Category[], Error>(
    CATEGORIES_KEY,
    fetchCategories,
    { revalidateOnFocus: false, shouldRetryOnError: false },
  );

  if (error) {
    return {
      status: 'error',
      message: error.message || 'Không tải được danh mục.',
      retry: () => {
        void mutate();
      },
    };
  }

  if (isLoading || !data) return { status: 'loading' };

  return { status: 'ready', categories: data, refresh: () => mutate() };
}
